import { Link } from 'react-router-dom';
import ScrollReveal from '../components/ScrollReveal';
import Seo from '../components/Seo';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getIletisimPage } from '../services/api';

const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001');
// INITIAL state'e honeypot için 'website' alanı eklendi
const INITIAL = { ad: '', soyad: '', email: '', telefon: '', sirket: '', pozisyon: '', calisanSayisi: '', konu: 'demo', mesaj: '', kvkk: false, website: '' };

const DEFAULT_CONTACT_SECTION = {
  formTitle: 'Demo Talep & İletişim & Destek Formu',
  formTitle_en: 'Demo Request & Contact & Support Form',
  sidebarTitle: 'İletişim Bilgileri',
  sidebarTitle_en: 'Contact Information',
  testimonialQuote: 'RUZY ile çalışmaktan çok memnun kaldık. ISO 27001 sürecimizi hem hızlandırdı hem de çok daha düzenli ve güvenilir hale getirdi. Süreç boyunca sağladıkları destek ve profesyonellik gerçekten çok başarılıydı.',
  testimonialQuote_en: 'We were very pleased working with RUZY. They significantly accelerated our ISO 27001 process and made it much more organized and reliable.',
  testimonialAuthor: 'Ahmet K.',
  trustBadges: [
    { icon: 'verified', text: 'Hızlı Geri Dönüş', text_en: 'Fast Response' },
    { icon: 'verified', text: 'Uzman Destek', text_en: 'Expert Support' },
  ],
  contactDetails: [
    {
      icon: 'phone',
      label: 'Telefon',
      label_en: 'Phone',
      value: '+90 (312) 000 00 00',
      value_en: '+90 (312) 000 00 00',
      href: 'tel:+903120000000',
    },
    {
      icon: 'mail',
      label: 'E-posta',
      label_en: 'Email',
      value: 'info@ruzy.com',
      value_en: 'info@ruzy.com',
      href: 'mailto:info@ruzy.com',
    },
    {
      icon: 'location_on',
      label: 'Adres',
      label_en: 'Address',
      value: 'Ankara, Türkiye',
      value_en: 'Ankara, Türkiye',
    },
  ],
};

const Iletisim = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'tr';
  const tx = (tr, en) => (lang === 'en' ? (en || tr) : tr);

  const [pageData, setPageData] = useState(null);
  const [form, setForm] = useState(INITIAL);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [loadTime, setLoadTime] = useState(0); // Form yüklenme zamanı

  useEffect(() => {
    setLoadTime(Date.now()); // Sayfa yüklendiği anı kaydet
    getIletisimPage().then(res => {
      if (res) setPageData(res);
    }).finally(() => setPageLoading(false));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = type === 'checkbox' ? checked : value;

    if (name === 'ad' || name === 'soyad') {
      finalValue = value.replace(/[0-9]/g, '');
    }

    if (name === 'telefon') {
      finalValue = value.replace(/[^0-9+\s()/-]/g, '');
    }

    setForm(prev => ({ ...prev, [name]: finalValue }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const e = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^[0-9+\s()/-]{10,20}$/;

    if (!form.ad.trim()) e.ad = lang === 'en' ? 'First name is required.' : 'Ad zorunludur.';
    else if (form.ad.length < 2) e.ad = lang === 'en' ? 'Too short.' : 'Çok kısa.';

    if (!form.soyad.trim()) e.soyad = lang === 'en' ? 'Last name is required.' : 'Soyad zorunludur.';

    if (!form.email.trim()) e.email = lang === 'en' ? 'Email is required.' : 'E-posta zorunludur.';
    else if (!emailRegex.test(form.email)) e.email = lang === 'en' ? 'Enter a valid email address.' : 'Geçerli bir e-posta girin.';

    if (!form.telefon.trim()) e.telefon = lang === 'en' ? 'Phone is required.' : 'Telefon zorunludur.';
    else if (!phoneRegex.test(form.telefon)) e.telefon = lang === 'en' ? 'Invalid phone format.' : 'Geçersiz telefon formatı.';

    if (!form.sirket.trim()) e.sirket = lang === 'en' ? 'Company name is required.' : 'Şirket adı zorunludur.';
    if (!form.kvkk) e.kvkk = lang === 'en' ? 'You must accept the privacy notice.' : 'KVKK metnini onaylamanız gerekmektedir.';

    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    // honeypot form alanı
    if (form.website) {
      console.warn("Spam detected via honeypot.");
      return;
    }

    // gönderim süresi min 5 sn
    const timeElapsed = (Date.now() - loadTime) / 1000;
    if (timeElapsed < 5) {
      alert(lang === 'en' ? 'Please fill the form.' : 'Lütfen formu doldurun.');
      return;
    }

    const e2 = validate();
    if (Object.keys(e2).length > 0) { setErrors(e2); return; }

    try {
      setLoading(true);
      const payload = {
        ...form,
        ad: form.ad.trim(),
        soyad: form.soyad.trim(),
        email: form.email.trim(),
        sirket: form.sirket.trim(),
        mesaj: form.mesaj.trim()
      };

      const response = await fetch(`${API_BASE_URL}/api/send-demo-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.success) setSubmitted(true);
      else alert(lang === 'en' ? 'An error occurred, please try again.' : 'Bir hata oluştu, lütfen tekrar deneyin.');
    } catch (error) {
      console.error("Bağlantı hatası:", error);
      alert(lang === 'en' ? 'Could not reach the server.' : 'Sunucuya ulaşılamadı.');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = (field) =>
    `w-full bg-[#f8fafb] border rounded-xl px-4 py-3.5 text-sm lg:text-base text-[#0f172a] outline-none transition-all font-poppins placeholder-[#94a3b8] focus:bg-white ${errors[field] ? 'border-red-500' : 'border-[#e2e8f0] focus:border-[#4BA18C] focus:shadow-[0_0_0_3px_rgba(15,189,73,0.15)]'}`;

  if (pageLoading) return <div className="p-20 text-center font-poppins">{lang === 'en' ? 'Loading...' : 'Yükleniyor...'}</div>;
  if (!pageData) return null;

  const contactSections = pageData.pageContent?.filter(s => s.__component === 'sections.contact-section') || [];
  const sectionRaw = contactSections[0];
  const section = {
    ...DEFAULT_CONTACT_SECTION,
    ...sectionRaw,
    contactDetails: sectionRaw?.contactDetails?.length ? sectionRaw.contactDetails : DEFAULT_CONTACT_SECTION.contactDetails,
    trustBadges: sectionRaw?.trustBadges?.length ? sectionRaw.trustBadges : DEFAULT_CONTACT_SECTION.trustBadges,
  };

  const testimonials = contactSections
    .filter(s => s.testimonialQuote || s.testimonialQuote_en || s.testimonialAuthor)
    .map(s => ({
      quote: tx(s.testimonialQuote, s.testimonialQuote_en),
      author: s.testimonialAuthor || 'RUZY Kullanıcısı',
    }));

  const activeTestimonials = testimonials.length ? testimonials : [{ quote: tx(section.testimonialQuote, section.testimonialQuote_en), author: section.testimonialAuthor }];
  const currentTestimonial = activeTestimonials[testimonialIndex];

  const nextTestimonial = () => setTestimonialIndex(prev => (prev + 1) % activeTestimonials.length);
  const prevTestimonial = () => setTestimonialIndex(prev => prev === 0 ? activeTestimonials.length - 1 : prev - 1);

  return (
    <>
      <style>
        {`
          @keyframes testimonialEnter {
            from { opacity: 0; transform: translateX(20px); filter: blur(4px); }
            to { opacity: 1; transform: translateX(0); filter: blur(0); }
          }
        `}
      </style>

      <Seo title={lang === 'en' ? 'Contact, Demo and Support | RUZY' : 'İletişim, Demo ve Destek | RUZY'} path="/iletisim" />

      <ScrollReveal>
        <div className="min-h-screen bg-[#f6f8f6] font-poppins text-[#0f172a] overflow-x-hidden">
          <section className="py-10 lg:py-16">
            <div className="max-w-[1280px] mx-auto px-6 lg:px-10 flex flex-col lg:grid gap-10 lg:grid-cols-[1fr_380px]">

              <div className="bg-white border border-[#e8eee9] rounded-2xl shadow-sm overflow-hidden order-1 lg:order-1">
                {submitted ? (
                  <div className="p-10 lg:p-16 flex flex-col items-center text-center gap-5">
                    <div className="w-[72px] h-[72px] rounded-full bg-[rgba(15,189,73,0.1)] flex items-center justify-center">
                      <span className="material-symbols-outlined text-4xl text-[#4BA18C]">check_circle</span>
                    </div>
                    <h2 className="text-2xl lg:text-3xl font-black m-0">{lang === 'en' ? 'Your Request Received!' : 'Talebiniz Alındı!'}</h2>
                    <p className="text-sm lg:text-base text-[#475569] max-w-md m-0">{lang === 'en' ? 'Our team will contact you shortly.' : 'En geç 1 iş günü içinde ekibimiz sizinle iletişime geçecek.'}</p>
                    <Link to="/" className="inline-flex items-center justify-center h-14 px-8 text-sm font-bold rounded-xl bg-[#4BA18C] text-white no-underline">{lang === 'en' ? 'Return to Home' : 'Ana Sayfaya Dön'}</Link>
                  </div>
                ) : (
                  <form className="p-6 lg:p-10 flex flex-col gap-6" onSubmit={handleSubmit} noValidate>
                    <h2 className="text-xl lg:text-2xl font-black text-[#0f172a] m-0">{tx(section.formTitle, section.formTitle_en)}</h2>

                    {/* GÜVENLİK: Honeypot Alanı (Kullanıcı Göremez) */}
                    <div style={{ display: 'none' }} aria-hidden="true">
                      <input type="text" name="website" value={form.website} onChange={handleChange} tabIndex="-1" autoComplete="off" />
                    </div>

                    <div className="text-[10px] lg:text-xs font-bold tracking-[2px] uppercase text-[#4BA18C] pb-2 border-b border-[#e8eee9]">
                      {lang === 'en' ? 'Subject' : 'Konu'}
                    </div>
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5">
                      {[
                        { val: 'demo', label: lang === 'en' ? 'Free Demo' : 'Ücretsiz Demo', icon: 'play_circle' },
                        { val: 'teklif', label: lang === 'en' ? 'Price Quote' : 'Fiyat Teklifi', icon: 'request_quote' },
                        { val: 'bilgi', label: lang === 'en' ? 'General Info' : 'Genel Bilgi', icon: 'info' },
                        { val: 'destek', label: lang === 'en' ? 'Support' : 'Destek', icon: 'support_agent' }
                      ].map(k => (
                        <label key={k.val} className={`flex flex-col items-center gap-1.5 py-3.5 px-2 rounded-xl border-[1.5px] cursor-pointer text-[10px] lg:text-xs font-bold text-center transition-all ${form.konu === k.val ? 'border-[#4BA18C] bg-[rgba(15,189,73,0.08)] text-[#4BA18C]' : 'border-[#e2e8f0] bg-[#f8fafb] text-[#475569]'}`}>
                          <input type="radio" name="konu" value={k.val} checked={form.konu === k.val} onChange={handleChange} className="hidden" />
                          <span className={`material-symbols-outlined text-xl ${form.konu === k.val ? 'text-[#4BA18C]' : 'text-[#94a3b8]'}`}>{k.icon}</span>
                          {k.label}
                        </label>
                      ))}
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">Ad <span className="text-red-500">*</span></label>
                        <input name="ad" type="text" maxLength={50} placeholder="Adınız" value={form.ad} onChange={handleChange} className={inputClass('ad')} />
                        {errors.ad && <span className="text-[10px] text-red-500 font-medium">{errors.ad}</span>}
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">Soyad <span className="text-red-500">*</span></label>
                        <input name="soyad" type="text" maxLength={50} placeholder="Soyadınız" value={form.soyad} onChange={handleChange} className={inputClass('soyad')} />
                        {errors.soyad && <span className="text-[10px] text-red-500 font-medium">{errors.soyad}</span>}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">{lang === 'en' ? 'Corporate Email' : 'Kurumsal E-posta'} *</label>
                        <input name="email" type="email" maxLength={100} placeholder="ad@sirket.com" value={form.email} onChange={handleChange} className={inputClass('email')} />
                        {errors.email && <span className="text-[10px] text-red-500 font-medium">{errors.email}</span>}
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">{lang === 'en' ? 'Phone' : 'Telefon'} *</label>
                        <input name="telefon" type="tel" maxLength={20} placeholder="+90 5xx..." value={form.telefon} onChange={handleChange} className={inputClass('telefon')} />
                        {errors.telefon && <span className="text-[10px] text-red-500 font-medium">{errors.telefon}</span>}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">{lang === 'en' ? 'Company' : 'Şirket Adı'} *</label>
                        <input name="sirket" type="text" maxLength={100} placeholder="Şirketiniz" value={form.sirket} onChange={handleChange} className={inputClass('sirket')} />
                        {errors.sirket && <span className="text-[10px] text-red-500 font-medium">{errors.sirket}</span>}
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">{lang === 'en' ? 'Position' : 'Pozisyon'}</label>
                        <input name="pozisyon" type="text" maxLength={100} placeholder="Pozisyonunuz" value={form.pozisyon} onChange={handleChange} className={inputClass('pozisyon')} />
                      </div>
                    </div>

                    <div className="flex flex-col gap-1.5">
                      <div className="flex justify-between items-center">
                        <label className="text-xs lg:text-sm font-bold text-[#374151]">{lang === 'en' ? 'Message' : 'Mesajınız'}</label>
                        <span className={`text-[10px] font-bold ${form.mesaj.length > 1900 ? 'text-red-500' : 'text-[#94a3b8]'}`}>{form.mesaj.length} / 2000</span>
                      </div>
                      <textarea name="mesaj" rows="3" maxLength={2000} placeholder="Notlarınız..." value={form.mesaj} onChange={handleChange} className={inputClass('mesaj') + ' resize-none min-h-[120px]'} />
                    </div>

                    <label className={`flex items-start gap-2.5 text-xs lg:text-sm cursor-pointer py-1 ${errors.kvkk ? 'text-red-500' : 'text-[#475569]'}`}>
                      <input type="checkbox" name="kvkk" checked={form.kvkk} onChange={handleChange} className="w-4 h-4 mt-0.5" />
                      <span className="font-medium">{lang === 'en' ? 'I accept the privacy notice.' : 'KVKK metnini okudum ve onaylıyorum.'}</span>
                    </label>

                    <button type="submit" disabled={loading} className="w-full h-14 bg-[#4BA18C] text-white font-bold rounded-xl hover:bg-[#3d8272] transition-colors shadow-lg disabled:opacity-70">
                      {loading ? (lang === 'en' ? 'Sending...' : 'Gönderiliyor...') : (lang === 'en' ? 'Submit Request' : 'Talebi Gönder')}
                    </button>
                  </form>
                )}
              </div>

              <aside className="flex flex-col gap-6 order-2 lg:order-2">
                <div className="bg-white border border-[#e8eee9] rounded-2xl p-6 lg:p-7 shadow-sm">
                  <h3 className="text-base lg:text-lg font-black mb-5">{tx(section.sidebarTitle, section.sidebarTitle_en)}</h3>
                  <ul className="list-none p-0 m-0 flex flex-col gap-5">
                    {section.contactDetails?.map((c, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-xl bg-[rgba(15,189,73,0.1)] text-[#4BA18C] flex items-center justify-center shrink-0">
                          <span className="material-symbols-outlined text-lg">{c.icon}</span>
                        </div>
                        <div className="flex flex-col min-w-0">
                          <span className="text-[10px] font-bold tracking-wide uppercase text-[#94a3b8]">{tx(c.label, c.label_en)}</span>
                          <span className="text-sm font-bold text-[#0f172a] break-words">{tx(c.value, c.value_en)}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="relative bg-[#0f172a] border border-[#1e293b] rounded-2xl p-6 lg:p-7 shadow-xl overflow-hidden select-none">
                  {activeTestimonials.length > 1 && (
                    <div className="absolute right-4 top-4 flex gap-1 z-20">
                      <button onClick={prevTestimonial} className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/5 text-white/50 hover:bg-white/10 hover:text-white transition-all">
                        <span className="material-symbols-outlined text-xl">chevron_left</span>
                      </button>
                      <button onClick={nextTestimonial} className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/5 text-white/50 hover:bg-white/10 hover:text-white transition-all">
                        <span className="material-symbols-outlined text-xl">chevron_right</span>
                      </button>
                    </div>
                  )}
                  <div key={testimonialIndex} className="animate-[testimonialEnter_0.5s_ease-out]">
                    <span className="material-symbols-outlined text-4xl text-[#4BA18C]/40 block mb-3">format_quote</span>
                    <p className="text-xs lg:text-sm text-[#e2e8f0] leading-relaxed mb-6 italic">{currentTestimonial.quote}</p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-[#4BA18C]/20 text-[#4BA18C] flex items-center justify-center text-[10px] font-black">
                        {currentTestimonial.author?.substring(0, 2).toUpperCase()}
                      </div>
                      <strong className="text-xs text-white">{currentTestimonial.author}</strong>
                    </div>
                  </div>
                </div>

                <div className="px-1">
                  <p className="text-[10px] font-bold tracking-[2px] uppercase text-[#94a3b8] mb-3">{lang === 'en' ? 'Trust Indicators' : 'Güven Göstergeleri'}</p>
                  <div className="flex flex-wrap gap-2">
                    {section.trustBadges?.map((t, i) => (
                      <div key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-[#e8eee9] rounded-full text-[10px] font-bold text-[#374151]">
                        <span className="material-symbols-outlined text-base text-[#4BA18C]">{t.icon}</span>
                        {tx(t.text, t.text_en)}
                      </div>
                    ))}
                  </div>
                </div>
              </aside>

            </div>
          </section>
        </div>
      </ScrollReveal>
    </>
  );
};

export default Iletisim;